"use client";

import { useRef } from "react";
import { L } from "./tokens";
import { ScrollReveal } from "./ScrollReveal";
import { PillButton } from "./PillButton";

export function FinalCTA({ locale }: { locale: string }) {
  const spotRef = useRef<HTMLDivElement>(null);

  // spotlight: mancha violeta que sigue al cursor dentro de la sección.
  function handleMouseMove(e: React.MouseEvent<HTMLElement>) {
    const spot = spotRef.current;
    if (!spot) return;
    const r = e.currentTarget.getBoundingClientRect();
    spot.style.setProperty("--sx", `${(((e.clientX - r.left) / r.width) * 100).toFixed(1)}%`);
    spot.style.setProperty("--sy", `${(((e.clientY - r.top) / r.height) * 100).toFixed(1)}%`);
  }

  return (
    <section
      id="cta"
      className="relative overflow-hidden"
      style={{ background: L.bgDark, padding: "110px 0" }}
      onMouseEnter={() => spotRef.current?.classList.add("tl-spot-on")}
      onMouseLeave={() => spotRef.current?.classList.remove("tl-spot-on")}
      onMouseMove={handleMouseMove}
    >
      <div
        className="tl-cta-glow pointer-events-none absolute"
        style={{
          width: 900, height: 600, left: "50%", top: "-30%",
          background: "radial-gradient(ellipse at center, rgba(107,92,255,.32), rgba(107,92,255,.1) 45%, transparent 70%)",
        }}
      />
      {/* Textura de puntitos, enmascarada en elipse — solo visible cerca del centro-arriba */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          backgroundImage: "radial-gradient(rgba(255,255,255,.14) 1px, transparent 1px)",
          backgroundSize: "26px 26px",
          WebkitMaskImage: "radial-gradient(ellipse at 50% 30%, black 20%, transparent 70%)",
          maskImage: "radial-gradient(ellipse at 50% 30%, black 20%, transparent 70%)",
        }}
      />
      <div
        className="pointer-events-none absolute"
        style={{
          width: 500, height: 500, right: "-10%", bottom: "-20%", borderRadius: "50%",
          background: "radial-gradient(circle, rgba(212,255,90,.16), transparent 65%)",
        }}
      />
      {/* spotlight: sigue al cursor, solo visible con el mouse encima */}
      <div ref={spotRef} className="tl-spot pointer-events-none absolute inset-0" />

      <ScrollReveal>
        <div className="relative mx-auto max-w-[820px] px-8 text-center">
          <h2 style={{ fontFamily: L.fontDisplay, fontWeight: 800, letterSpacing: "-0.025em", lineHeight: 1, fontSize: "clamp(44px, 6vw, 80px)", color: "#fff", margin: "0 0 20px" }}>
            Probalo con tu próxima búsqueda y bajá el <em style={{ fontStyle: "normal", color: L.lime }}>time-to-hire.</em>
          </h2>
          <p style={{ fontSize: 19, lineHeight: 1.45, color: "rgba(255,255,255,.65)", maxWidth: 560, margin: "0 auto 32px" }}>
            20 minutos de demo. Cargamos una búsqueda real, te mostramos el sistema funcionando y vos decidís.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <PillButton href={`/${locale}/demo`} variant="violet">Agendá una demo</PillButton>
            <PillButton href={`/${locale}/plans`} variant="ghost-on-dark">Registrate</PillButton>
          </div>
          <p className="mt-6" style={{ fontSize: 13.5, color: "rgba(255,255,255,.5)" }}>
            O escribinos a <a href="mailto:hola@talenv.com" style={{ color: L.lime }}>hola@talenv.com</a>
          </p>
        </div>
      </ScrollReveal>
    </section>
  );
}
